module.exports = __webpack_public_path__ + "media/assets/svg/logos/logo-5deccc6100cbb0e3c2c493ec6645c645.svg";